import { InjectionToken } from '@angular/core';

export interface DecoratorHost {
  setInputId(inputId: string | null): void;
  getInputId(): string | null;
}

export const DECORATOR_HOST = new InjectionToken<DecoratorHost>('DECORATOR_HOST');
